module.exports = __webpack_public_path__ + "static/media/Hamburg26.f1682f7a.jpg";